import styled from 'styled-components'

import { StatusBoxStyled } from '../../../components/component-items/status-box'

export const UploadOrdersStyled = styled.div`
  .content {
    margin: 2em auto;
    max-width: calc(100% - 2rem);
    min-width: 0;
    width: 70%;
  }

  .importer-body {
    max-width: 100%;
    min-height: 500px;
    min-width: 0;
  }

  .importer-footer {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    justify-content: flex-end;
    margin-top: 1.25rem;
  }

  .plain-action {
    background: transparent;
    border: 0;
    color: #5d78ff;
    font-weight: 700;
    padding: 0.65rem 0.4rem;
  }

  .plain-action.selected {
    border-bottom: 2px solid #5d78ff;
  }

  .template-link {
    background: transparent;
    border: 0;
    color: #5d78ff;
    font-weight: 700;
    padding: 0;
  }

  .save-preset-button {
    background: #5d78ff;
    border: 1px solid #5d78ff;
    border-radius: 4px;
    color: #ffffff;
    font-size: 0.86rem;
    font-weight: 700;
    padding: 0.45rem 0.75rem;
  }

  .mapping-next-button:disabled,
  .mapping-next-button:disabled:hover,
  .mapping-next-button[aria-disabled='true'],
  .mapping-next-button[aria-disabled='true']:hover {
    background: #c5c8d3;
    color: #ffffff;
    cursor: not-allowed;
    opacity: 0.8;
  }

  .mapping-blocker-message {
    color: #c51f59;
    font-size: 0.82rem;
    font-weight: 600;
    margin-right: auto;
  }

  .muted {
    color: #74788d;
  }

  .workflow-progress {
    margin: 2rem 0 3rem;
    padding: 0 1.5rem;
  }

  .workflow-progress ul {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    list-style: none;
    margin: 0;
    padding: 0;
    position: relative;
  }

  .workflow-progress ul::before {
    border-top: solid 2px #d8d8d8;
    content: '';
    left: calc(12.5% - 19px);
    position: absolute;
    right: calc(12.5% - 19px);
    top: 18px;
  }

  .workflow-progress li {
    align-items: center;
    display: flex;
    flex-direction: column;
    position: relative;
    text-align: center;
    z-index: 1;
  }

  .workflow-progress .step-card {
    align-items: center;
    background: #f2f3f8;
    border: 4px solid #ffffff;
    border-radius: 50%;
    box-sizing: border-box;
    color: #8a8d9f;
    display: flex;
    height: 38px;
    justify-content: center;
    width: 38px;
  }

  .workflow-progress .icon {
    font-size: 1.25rem;
  }

  .workflow-progress .text {
    color: #74788d;
    font-size: 1rem;
    font-weight: 500;
    margin-top: 0.75rem;
  }

  .workflow-progress li.active .step-card {
    background: #eef2ff;
    color: #000eb7;
    outline: 2px solid #000eb7;
  }

  .workflow-progress li.active .text {
    color: #000eb7;
  }

  .workflow-progress li.complete .step-card {
    background: #e8faf8;
    color: #1dc9b7;
  }

  .workflow-progress li.complete .text {
    color: #1dc9b7;
  }

  .upload-panel {
    margin: 0 auto;
    max-width: 620px;
  }

  .upload-message {
    margin: 0 auto 1.5rem;
    max-width: 620px;
  }

  .file-meta {
    background: #f7f8fa;
    border: 1px solid #ebedf2;
    border-radius: 4px;
    margin-top: 1rem;
    padding: 1rem;
  }

  .match-list,
  .validation-panel {
    border: 1px solid #ebedf2;
    border-radius: 4px;
  }

  .validation-panel {
    max-width: 100%;
    min-width: 0;
    overflow: hidden;
    width: 100%;
  }

  .match-list-header,
  .validation-header {
    background: #f7f8fa;
    border-bottom: 1px solid #ebedf2;
    font-weight: 700;
    padding: 0.75rem 1rem;
  }

  .validation-header {
    align-items: center;
    display: flex;
    gap: 1rem;
    justify-content: space-between;
  }

  .fullscreen-toggle {
    align-items: center;
    background: #ffffff;
    border: 1px solid #dfe3eb;
    border-radius: 4px;
    color: #74788d;
    display: inline-flex;
    font-size: 0.78rem;
    font-weight: 700;
    gap: 0.4rem;
    padding: 0.4rem 0.6rem;
  }

  .fullscreen-toggle:hover {
    background: #f6f9ff;
    border-color: #c8ceda;
    color: #5d78ff;
  }

  .validation-panel.fullscreen {
    background: #ffffff;
    bottom: 0;
    display: flex;
    flex-direction: column;
    left: 0;
    overflow: hidden;
    padding: 1rem;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 1060;
  }

  .validation-panel.fullscreen .table-wrap {
    flex: 1;
    height: 0;
    overflow: auto;
    width: 100%;
  }

  .validation-panel.fullscreen thead th {
    background: #f7f8fa;
    position: sticky;
    top: 0;
    z-index: 2;
  }

  .validation-panel.fullscreen thead th.status-column,
  .validation-panel.fullscreen thead th.action-column {
    z-index: 22;
  }

  .validation-panel.fullscreen .importer-footer {
    flex: 0 0 auto;
    margin-top: 0.75rem;
  }

  .preset-actions {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
  }

  .match-section + .match-section {
    border-top: 1px solid #dfe3eb;
  }

  .match-section-heading {
    align-items: baseline;
    background: #ffffff;
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem 1rem;
    justify-content: space-between;
    padding: 1rem;
  }

  .match-section-heading h5 {
    color: #3f4254;
    font-size: 0.95rem;
    margin: 0;
  }

  .match-section-heading span {
    font-size: 0.8rem;
  }

  .match-subsection {
    background: #f7f8fa;
    border-bottom: 1px solid #ebedf2;
    color: #5d78ff;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    padding: 0.55rem 1rem;
    text-transform: uppercase;
  }

  .match-table-header {
    align-items: center;
    background: #fbfbfd;
    border-bottom: 1px solid #ebedf2;
    color: #74788d;
    display: grid;
    font-size: 0.76rem;
    font-weight: 700;
    column-gap: 1.25rem;
    grid-template-columns: minmax(190px, 0.8fr) minmax(320px, 1.2fr) 64px;
    letter-spacing: 0.02em;
    padding: 0.65rem 1rem;
    text-transform: uppercase;
  }

  .match-table-header span:last-child {
    justify-self: center;
  }

  .match-row {
    align-items: center;
    border-bottom: 1px solid #ebedf2;
    display: grid;
    column-gap: 1.25rem;
    grid-template-columns: minmax(190px, 0.8fr) minmax(320px, 1.2fr) 64px;
    padding: 0.65rem 1rem;
  }

  .match-row > * {
    min-width: 0;
  }

  .match-row:last-child {
    border-bottom: 0;
  }

  .sample-text {
    color: #74788d;
    font-size: 0.86rem;
  }

  .field-name {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: 0.45rem;
  }

  .required-marker {
    border: 1px solid #ffb822;
    border-radius: 999px;
    color: #9b6d00;
    font-size: 0.68rem;
    font-weight: 700;
    line-height: 1;
    padding: 0.22rem 0.42rem;
    text-transform: uppercase;
  }

  .conditional-marker {
    background: #f7f8fa;
    border-radius: 3px;
    color: #74788d;
    font-size: 0.7rem;
    font-weight: 600;
    padding: 0.22rem 0.42rem;
  }

  .form-required {
    color: #fd397a;
    font-size: 0.68rem;
    font-weight: 700;
    margin-left: 0.25rem;
    text-transform: uppercase;
  }

  .conditional-label {
    color: #74788d;
    font-size: 0.7rem;
    font-weight: 600;
    margin-left: 0.25rem;
  }

  .unmapped-source-columns {
    background: #fff9e6;
    border-top: 1px solid rgba(255, 184, 34, 0.45);
    padding: 1rem;
  }

  .unmapped-source-heading {
    align-items: center;
    color: #7a5700;
    display: flex;
    font-size: 0.84rem;
    font-weight: 700;
    gap: 0.45rem;
  }

  .unmapped-source-heading svg {
    color: #ffb822;
  }

  .unmapped-source-columns p {
    font-size: 0.78rem;
    margin: 0.3rem 0 0.65rem;
  }

  .unmapped-source-list {
    display: flex;
    flex-wrap: wrap;
    gap: 0.45rem;
  }

  .unmapped-source-chip {
    background: #ffffff;
    border: 1px solid rgba(255, 184, 34, 0.55);
    border-radius: 3px;
    color: #7a5700;
    font-size: 0.75rem;
    font-weight: 600;
    padding: 0.3rem 0.5rem;
  }

  .summary-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 0.75rem;
    margin-bottom: 1rem;
  }

  .summary-card {
    background: #f7f8fa;
    border: 1px solid #ebedf2;
    border-radius: 4px;
    padding: 0.75rem 1rem;
  }

  .summary-card strong {
    color: #242939;
    display: block;
    font-size: 1.2rem;
  }

  .error-callout {
    background: #fff5f8;
    border: 1px solid rgba(253, 57, 122, 0.25);
    border-radius: 4px;
    margin-bottom: 1rem;
    padding: 1rem;
  }

  .error-callout strong {
    color: #fd397a;
    display: block;
    margin-bottom: 0.3rem;
  }

  .error-callout p {
    margin: 0;
  }

  .table-wrap {
    display: block;
    max-width: none;
    min-width: 100%;
    overflow-x: auto;
    overflow-y: visible;
    padding-bottom: 0.35rem;
    width: 0;
  }

  .table-wrap::-webkit-scrollbar {
    height: 8px;
  }

  .table-wrap::-webkit-scrollbar-thumb {
    background: #bbc2e5;
    border-radius: 999px;
  }

  .table-wrap::-webkit-scrollbar-track {
    background: #f2f3f8;
  }

  table {
    border-collapse: collapse;
    min-width: 860px;
    width: 100%;
  }

  .validation-panel table {
    min-width: 100%;
    width: max-content;
  }

  .validation-panel th,
  .validation-panel td {
    overflow-wrap: anywhere;
  }

  .validation-cell {
    max-width: 160px;
  }

  .editable-cell {
    cursor: text;
    min-width: 130px;
    transition:
      background 0.15s ease,
      box-shadow 0.15s ease;
  }

  .editable-cell:hover:not(.editing) {
    background: #f6f9ff;
    box-shadow: inset 0 0 0 1px #d9dffc;
  }

  .editable-cell.editing {
    background: #f6f9ff;
    box-shadow: inset 0 0 0 2px #5d78ff;
    padding: 0.3rem;
  }

  .cell-edit-trigger {
    background: transparent;
    border: 0;
    color: inherit;
    cursor: text;
    display: block;
    font: inherit;
    padding: 0;
    text-align: inherit;
    width: 100%;
  }

  .cell-edit-trigger:focus-visible {
    border-radius: 3px;
    box-shadow: 0 0 0 2px #5d78ff;
    outline: 0;
  }

  .editable-cell .form-control,
  .editable-cell .form-select {
    border: 0;
    box-shadow: none;
    font-size: 0.82rem;
    min-width: 120px;
    padding: 0.4rem 0.45rem;
  }

  .editable-cell-value.empty {
    color: #a7abc3;
    font-style: italic;
  }

  .validation-cell.compact {
    max-width: 90px;
  }

  .validation-cell.date {
    max-width: 190px;
  }

  .validation-cell.address {
    max-width: 220px;
  }

  .validation-cell.billing-account {
    max-width: 230px;
  }

  .validation-cell.items {
    max-width: 260px;
  }

  .validation-cell.actions {
    max-width: 96px;
    min-width: 96px;
    text-align: center;
    width: 96px;
  }

  .match-status-icon {
    color: #51e2d3;
    font-size: 1.05rem;
    justify-self: center;
  }

  .match-status-icon.ignored {
    color: #a7abc3;
  }

  .match-status-icon.required-missing {
    color: #fd397a;
  }

  .row-action-cell {
    display: flex;
    justify-content: center;
  }

  .row-action-button {
    align-items: center;
    background: #ffffff;
    border: 1px solid #d9dffc;
    border-radius: 4px;
    color: #5d78ff;
    display: inline-flex;
    font-size: 0.88rem;
    font-weight: 700;
    gap: 0.4rem;
    height: 2rem !important;
    justify-content: center;
    padding: 0 0.55rem;
    width: auto !important;
  }

  .row-action-button:hover {
    background: #f6f9ff;
  }

  .delete-row-action {
    border-color: #dfe3eb;
    color: #74788d;
    font-size: 0.78rem;
    padding: 0 0.5rem;
  }

  .delete-row-action:hover {
    background: #f7f8fa;
    border-color: #c8ceda;
  }

  .item-lines {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
  }

  .item-line {
    align-items: center;
    background: #f7f8fa;
    border: 1px solid #ebedf2;
    border-radius: 4px;
    display: flex;
    gap: 0.5rem;
    justify-content: space-between;
    padding: 0.35rem 0.5rem;
    white-space: nowrap;
  }

  .item-line strong {
    color: #495057;
    font-weight: 700;
  }

  .item-line span {
    color: #74788d;
    font-size: 0.82rem;
    font-weight: 700;
  }

  .validation-cell.validation-error {
    background: #fff5f8;
    box-shadow: inset 0 0 0 1px rgba(253, 57, 122, 0.35);
  }

  .editable-cell.editing.validation-error {
    box-shadow: inset 0 0 0 2px #5d78ff;
  }

  .validation-cell.validation-warning {
    background: #fffbef;
    box-shadow: inset 0 0 0 1px rgba(255, 184, 34, 0.45);
  }

  .item-line.item-error {
    background: #fff0f5;
    border-color: rgba(253, 57, 122, 0.55);
  }

  .item-line.item-error strong,
  .item-line.item-error span {
    color: #b92059;
  }

  .field-error-message {
    color: #c51f59;
    font-size: 0.72rem;
    font-weight: 600;
    line-height: 1.35;
    margin-top: 0.4rem;
  }

  .field-error-message.warning {
    color: #8a6500;
  }

  .inline-items-editor {
    min-width: 260px;
  }

  .inline-item-row {
    align-items: center;
    display: grid;
    gap: 0.35rem;
    grid-template-columns: minmax(110px, 1fr) 72px 28px;
    margin-bottom: 0.35rem;
  }

  .inline-item-row .form-control {
    border: 1px solid #d9dffc;
    min-width: 0;
  }

  .inline-item-action {
    align-items: center;
    background: transparent;
    border: 0;
    color: #fd397a;
    display: inline-flex;
    justify-content: center;
    padding: 0.35rem;
  }

  .add-item-button {
    align-items: center;
    background: transparent;
    border: 0;
    color: #5d78ff;
    display: inline-flex;
    font-size: 0.76rem;
    font-weight: 700;
    gap: 0.35rem;
    padding: 0.25rem 0;
  }

  .drawer-backdrop {
    background: rgba(36, 41, 57, 0.36);
    bottom: 0;
    display: flex;
    justify-content: flex-end;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 1050;
  }

  .edit-drawer {
    background: #ffffff;
    box-shadow: -12px 0 32px rgba(36, 41, 57, 0.18);
    display: flex;
    flex-direction: column;
    max-width: 680px;
    min-width: 0;
    width: min(680px, 100vw);
  }

  .edit-drawer-header,
  .edit-drawer-footer {
    align-items: center;
    border-bottom: 1px solid #ebedf2;
    display: flex;
    gap: 1rem;
    justify-content: space-between;
    padding: 1rem 1.25rem;
  }

  .edit-drawer-footer {
    border-bottom: 0;
    border-top: 1px solid #ebedf2;
    justify-content: flex-end;
  }

  .edit-drawer-body {
    flex: 1;
    overflow: auto;
    padding: 1.25rem;
  }

  .edit-section {
    border: 1px solid #ebedf2;
    border-radius: 4px;
    margin-bottom: 1rem;
    padding: 1rem;
  }

  .edit-section h5 {
    font-size: 0.95rem;
    margin: 0 0 0.85rem;
  }

  .edit-subsection {
    border-top: 1px solid #ebedf2;
    color: #74788d;
    font-size: 0.78rem;
    font-weight: 700;
    letter-spacing: 0.04em;
    margin: 1.1rem 0 0.85rem;
    padding-top: 0.85rem;
    text-transform: uppercase;
  }

  .edit-grid {
    display: grid;
    gap: 0.9rem;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .edit-grid .wide {
    grid-column: 1 / -1;
  }

  .drawer-items-table {
    min-width: 100%;
    width: 100%;
  }

  .drawer-items-table th,
  .drawer-items-table td {
    padding: 0.45rem;
  }

  th,
  td {
    border-bottom: 1px solid #ebedf2;
    padding: 0.75rem;
    text-align: left;
    vertical-align: top;
  }

  th {
    background: #f7f8fa;
    color: #595d6e;
    font-size: 0.78rem;
    text-transform: uppercase;
  }

  tr:last-child td {
    border-bottom: 0;
  }

  .validation-cell.date {
    position: relative;
    z-index: 1;
  }

  .status-column {
    align-items: center;
    background: #ffffff;
    display: table-cell;
    min-width: 110px;
    position: sticky;
    right: 96px;
    text-align: center;
    width: 110px;
    z-index: 20;
  }

  .status-column::before {
    background: #dfe3f1;
    bottom: 0;
    box-shadow: -8px 0 12px -12px rgba(36, 41, 57, 0.55);
    content: '';
    left: 0;
    position: absolute;
    top: 0;
    width: 1px;
  }

  .action-column {
    background: #ffffff;
    position: sticky;
    right: 0;
    text-align: center;
    z-index: 20;
  }

  th.status-column,
  th.action-column {
    background: #f7f8fa;
    z-index: 21;
  }

  .success-note {
    background: #f1fbf5;
    border: 1px solid rgba(29, 201, 183, 0.25);
    border-radius: 4px;
    margin: 0 auto;
    max-width: 620px;
    padding: 0.9rem 1rem;
  }

  @media (max-width: 1100px) {
    .content {
      width: calc(100% - 2rem);
    }

    .summary-grid {
      grid-template-columns: 1fr;
    }

    .workflow-progress ul {
      grid-template-columns: 1fr;
    }

    .workflow-progress ul::before {
      border-left: solid 2px #d8d8d8;
      border-top: 0;
      bottom: 10%;
      left: 19px;
      right: unset;
      top: 10%;
    }

    .workflow-progress li {
      align-items: flex-start;
      flex-direction: row;
      gap: 1rem;
      margin-bottom: 1rem;
      text-align: left;
    }

    .workflow-progress .text {
      margin-top: 0.45rem;
    }

    .match-table-header {
      display: none;
    }

    .match-row {
      gap: 0.65rem;
      grid-template-columns: 1fr;
    }

    .match-status-icon {
      justify-self: start;
    }
  }
`

export const ValidationStatusStyled = styled(StatusBoxStyled)`
  display: inline-flex;
  gap: 0.35rem;
  justify-content: center;
  min-width: 78px;
  padding: 0.35rem 0.5rem;
  font-size: 0.75rem;
  line-height: 1;
`
